const Marketing = {
  contact: () => {
    return 'marketing/contacts';
  },
};

export default Marketing;
